module.exports = __webpack_public_path__ + "img/belum-lunas.76d3596f.png";